import { render } from "./InternetOrders.vue?vue&type=template&id=ddc789ac"
import script from "./InternetOrders.vue?vue&type=script&lang=js"
export * from "./InternetOrders.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "ddc789ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ddc789ac', script)) {
    api.reload('ddc789ac', script)
  }
  
  module.hot.accept("./InternetOrders.vue?vue&type=template&id=ddc789ac", () => {
    api.rerender('ddc789ac', render)
  })

}

script.__file = "src/views/services/modules/internet/pills/InternetOrders.vue"

export default script